export default __webpack_public_path__ + "static/media/AmazonSmile_Business_Model.5c2ec402.png";